export default __webpack_public_path__ + "static/media/copy-icon.24d9a890.svg";